export * from './abschnitt-gespeichert.interface';
